import { flow, keyBy, pick, map } from 'lodash/fp';

export default (values, options) =>
  flow(
    keyBy('value'),
    pick(values),
    map('label')
  )(options);
